export function hasSeenHint(key: string): boolean {
	try {
		return window.localStorage.getItem(key) === "true";
	} catch {
		return false;
	}
}

export function markHintSeen(key: string): void {
	try {
		window.localStorage.setItem(key, "true");
	} catch {
		// Storage unavailable — the hint may show again next time; acceptable degradation.
	}
}
